import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
});

/*
 * Global request interceptor — cache-busting for all admin & catalog
 * GET requests. Some production CDNs / browser HTTP caches were caching
 * these endpoints, causing the UI to display stale data immediately
 * after a mutation (e.g. flavour reorder). Adding a `_ts` query param
 * plus explicit no-cache headers forces a fresh network fetch every time.
 */
api.interceptors.request.use((config) => {
    const method = (config.method || 'get').toLowerCase();
    if (method === 'get') {
        config.params = {
            ...(config.params || {}),
            _ts: Date.now(),
        };
        config.headers = {
            ...(config.headers || {}),
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
        };
    }
    return config;
});

// Attach token per-realm via requests. We keep three separate token slots.
export const TOKEN_KEYS = {
    distributor: 'sdf_dist_token',
    admin: 'sdf_admin_token',
    super_admin: 'sdf_superadmin_token',
};

export function getToken(realm) {
    return localStorage.getItem(TOKEN_KEYS[realm] || '') || '';
}
export function setToken(realm, token) {
    if (token) localStorage.setItem(TOKEN_KEYS[realm], token);
    else localStorage.removeItem(TOKEN_KEYS[realm]);
}

// Helper to fire an authed request with the correct token
export async function authed(realm, config) {
    const token = getToken(realm);
    return api.request({ ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } });
}

export function absUrl(pathOrUrl) {
    if (!pathOrUrl) return '';
    if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://') || pathOrUrl.startsWith('data:')) return pathOrUrl;
    return `${BACKEND_URL}${pathOrUrl}`;
}

export default api;
